var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "header-main"
  }, [_c('div', {
    staticClass: "loginDialogCover",
    style: {
      width: _vm.pageWidth + 'px',
      height: _vm.pageHeight + 'px'
    },
    on: {
      "click": _vm.loginDailogClick
    }
  }, [_c('div', {
    staticClass: "loginDialog"
  }, [_c('div', {
    staticClass: "loginDialogTop"
  }, [_c('div', {
    staticClass: "loginDialogTopL"
  }, [_c('img', {
    staticClass: "faceIcon",
    attrs: {
      "src": _vm.faceIcon
    }
  }), _vm.isVip.length ? _c('img', {
    staticClass: "vipIcon",
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230807161652.png"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "loginDialogTopR"
  }, [_c('div', {
    staticClass: "nickName"
  }, [_vm._v(_vm._s(_vm.nickName))]), _c('div', {
    staticClass: "userId"
  }, [_vm._v("用户ID：" + _vm._s(_vm.userId))]), _vm.isVip.length ? _c('div', {
    staticClass: "validate"
  }, [_vm._v(" 有效期：" + _vm._s(_vm.isVip) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "loginDialogBottom",
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v(" 退出登录 ")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };